import React, {useContext} from 'react';
import RemoveButtonCellRenderer from "./remove-button-cell-renderer";
import attachService from "../../services/attach-service";
import {ProjectContext} from "../../context/project-context";
import Button from "../button";

const AttachButtonGroupCellRenderer = ({api, node, setOpen, setEditingRowIndex, submit, readOnly = false}) => {

    const {user} = useContext(ProjectContext);
    const onlySeeAttendances = user.permissions.includes("see_attendances");
    const getAttachUrl = async () => {
        const {attachId} = node.data;

        const attach = await attachService.getAttach(attachId);

        return window.URL.createObjectURL(new Blob([attach]));
    }

    const downloadFile = async () => {
        const {name} = node.data;

        const url = await getAttachUrl();

        const link = document.createElement('a');
        link.href = url;
        link.download = name;
        link.click();

        window.URL.revokeObjectURL(url);
    }

    const handleSave = () => {
        if (submit) {
            submit();
        }

        setOpen(false);
        setEditingRowIndex(null);
    }
    return (
        <div className="flex flex-row justify-end h-full w-full gap-2">
            {
                node.data.attachId &&
                <Button onClick={downloadFile}>
                    Download
                </Button>
            }
            {
                !onlySeeAttendances && !readOnly &&
                <RemoveButtonCellRenderer api={api} node={node} modal={true} setOpen={setOpen} />
            }
            {
                submit && !readOnly &&
                <Button target="success" onClick={handleSave}>
                    Salvar
                </Button>
            }
        </div>
    );
};

export default AttachButtonGroupCellRenderer;
